const schema = () => {
  return {
    title: 'Button Row Block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'title',
          'text',
          'backgroundColor',
          'backgroundImage',
          'isFullWidth',
          'alignment',
          'buttonSource',
          'useH2',
          'useH3',
          'containedItemTypes',
          'smallButtons',
          'buttons',
        ],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        type: 'string',
      },
      text: {
        title: 'Text',
        type: 'string',
        widget: 'textarea',
      },
      backgroundColor: {
        title: 'Background colour',
        widget: 'select',
        choices: [
          ['#ffffff', 'White'],
          ['var(--lightblue)', 'Light Blue'],
          ['var(--lightgrey)', 'Light Grey'],
          ['var(--blue)', 'Blue'],
          ['var(--red)', 'Red'],
          ['var(--orange)', 'Orange'],
          ['var(--green)', 'Green'],
          ['var(--purple)', 'Purple'],
          ['var(--charcoal)', 'Charcoal'],
        ],
        default: 'var(--lightgrey)',
        requiresDarkButtons: ['#ffffff', 'var(--lightgrey)'],
      },
      backgroundImage: {
        title: 'Background image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: false,
      },
      isFullWidth: {
        title: 'Full width background',
        type: 'boolean',
        default: false,
      },
      alignment: {
        title: 'Text alignment',
        widget: 'align',
        actions: ['left', 'center', 'right'],
        default: 'center',
      },
      buttonSource: {
        title: 'Button source',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['contained', 'Use contained items as buttons'],
          ['toc', 'Use table of contents as buttons'],
          ['custom', 'Use custom buttons'],
        ],
        default: 'contained',
      },
      useH2: {
        title: 'Include H2 headings in TOC',
        type: 'boolean',
        default: true,
      },
      useH3: {
        title: 'Include H3 headings in TOC',
        type: 'boolean',
        default: true,
      },
      containedItemTypes: {
        title: 'Item types to display',
        widget: 'array',
        choices: [
          ['File', 'File'],
          ['Document', 'Page'],
          ['News Item', 'News Item'],
          ['Event', 'Event'],
          ['Image', 'Image'],
          ['Link', 'Link'],
        ],
        default: ['File'],
      },
      smallButtons: {
        title: 'Use smaller buttons',
        type: 'boolean',
        default: false,
      },
      buttons: {
        title: 'Buttons',
        widget: 'object_list',
        schema: {
          title: 'Button',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['label', 'link'],
            },
          ],
          properties: {
            label: {
              title: 'Label',
              type: 'string',
            },
            link: {
              title: 'Link',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: true,
              multi: false,
              default: null,
            },
          },
        },
      },
    },
    required: [],
  };
};

export default schema;